export class Entry {
  title: string;
  date: Date;
  notes: string;
}
